<script lang="ts">
	import { Button } from '$lib/shadcn/ui/button'
	import { HandHeart } from 'lucide-svelte'
</script>

<div class="col-span-full row-start-3 p-8 flex mx-auto gap-8 items-start">
	<div
		class="aspect-square border rounded-xl hidden lg:grid place-items-center p-10 w-[250px]"
	>
		<!-- TODO: Show example scene graph -->
		<HandHeart size="100%" strokeWidth="0.6" />
	</div>
	<div class="p-4 my-auto">
		<h2 class="text-4xl sm:text-5xl font-bold leading-tight">
			Get exclusive features
		</h2>
		<p class="text-xl mt-3 text-muted-foreground max-w-lg">
			Support Scenery and get access to exclusive features like <a
				class="text-white"
				href="/patrons#scene-graphs">Scene Graphs</a
			>, scripts and more.
		</p>
		<Button
			class="plausible-event-name--Patron w-fit mt-8 font-medium"
			href="/patrons"
		>
			Become a Patron
		</Button>
	</div>
</div>
